<template>
  <div>
    <div v-if="!firstLoading">
      <fieldset class="scheduler-border" v-if="formModel.type === 'sms' || (formModel.isAgainTwo && formModel.typeTwo === 'sms') || (formModel.isAgainThree && formModel.typeThree === 'sms')">
        <legend class="scheduler-border">{{$t("sms")}}</legend>
        <div class="row">
          <div class="col-lg-8">
            <h5 class="c-config-content__title">{{ $t('smsContent') }}</h5>
            <form-textarea v-if="formModel.type"
                           :disabled="true"
                           :model="formModel" attribute="content" :errors="formErrors"
                           :placeholder="$t('smsTemplateContentPlaceHolder')">
            </form-textarea>
            <div v-if="campaign.smsType === 'care' && formModel.sendParams && formModel.sendParams.length">
              <h5 class="c-config-content__title">{{ $t('paramList') }}</h5>
              <div class="row" v-for="(param, index) in formModel.sendParams" :key="param.key">
                <div class="col-md-3">
                  <div class="form-group">
                    <form-input :disabled="true" :model="formModel.sendParams[index]" attribute="key"
                                :errors="formErrors"></form-input>
                  </div>
                </div>
                <div class="col-md-3">
                  <form-select :disabled="true"
                               :model="formModel.sendParams[index]" attribute="inputType"
                               @change="inputTypeChange(index)"
                               :errors="formErrors" :options="inputTypeOptions"></form-select>
                </div>
                <div class="col-md-6">
                  <form-input :disabled="true"
                                v-if="param.inputType === 'text'"
                                :model="formModel.sendParams[index]" attribute="value" :errors="formErrors"
                                :placeholder="$t('maxlength', [formModel.sendParams[index].length])"
                                :maxlength="formModel.sendParams[index].length"
                                :index="index"
                                @keyup="loadParam"
                                :required="true"></form-input>
                  <form-select :disabled="true"
                               v-if="param.inputType === 'customField'" :model="formModel.sendParams[index]"
                               @keyup="loadParam"
                               attribute="value" :errors="formErrors" :options="customFieldOptions"></form-select>
                </div>
              </div>
              <div class="alert alert-info" v-html="$t('messageContentNotice')"></div>
            </div>
          </div>
          <div class="col-lg-4 mb-3">
            <h5 class="c-config-content__title text-center">{{ $t('preview') }}</h5>
            <div class="iphone">
              <div class="silence-switch outer-button"></div>
              <div class="volume-rocker-top outer-button"></div>
              <div class="volume-rocker-bottom outer-button"></div>
              <div class="power-button outer-button-reversed"></div>
              <div class="top-section">
                <i class="arrow left"></i>
                <div class="top-section-time">12:00</div>
                <div class="top-section-symbols">
                  <i class="fa fa-signal"></i>
                  <i class="fa fa-wifi"></i>
                  <i class="fa fa-battery-three-quarters"></i>
                </div>
                <div class="top-section-middle">
                  <div class="speaker">
                    <div class="front-camera"></div>
                  </div>
                  <div class="top-section-user-pic selectDisable"><i class="fa fa-user-circle"></i></div>
                  <div class="top-section-user-name">
                  <span v-if="formModel.smsBrandName && smsBrandNames.find(o => o._id === formModel.smsBrandName)">
                    {{ smsBrandNames.find(o => o._id === formModel.smsBrandName).name }}
                  </span>
                    <span v-else>BrandName</span>
                  </div>
                </div>
                <div class="messages-section" id="messages-left">
                  <div class="message from"
                       v-html="formModel.content ? formModel.content.replaceAll(`\n`, `<br/>`) : $t(`content`)"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="scheduler-border" v-if="formModel.type === 'viber' || (formModel.isAgainTwo && formModel.typeTwo === 'viber') || (formModel.isAgainThree && formModel.typeThree === 'viber')">
        <legend class="scheduler-border">{{ $t("viber") }}</legend>
        <div class="row">
          <div class="col-lg-3">
            <h5 class="c-config-content__title">{{ $t('paramList') }}</h5>
            <template v-for="customField in customFieldOptions">
              <button class="btn btn-outline-gray mr-1 mb-1 mt-1 btn-sm" v-if="customField.value"
                      :key="customField.value" @click="copy(`{${customField.value}}`)">
                {{ customField.text }} <span v-pre>{</span>{{ customField.value }}<span v-pre>}</span>
              </button>
            </template>

            <div class="alert-warning alert mt-2">
              <b>Lưu ý:</b>
              <div> - Ba tham số <b>{{ $t('viberActionText') }}, {{ $t('viberActionLink') }}, {{ $t('viberImg') }}</b>
                nếu
                sử dụng phải sử dụng đồng thời cả 03 hoặc hệ thống sẽ trả về lỗi.
              </div>
              <div> - Hai tham số <b>{{ $t('viberActionLink') }}, {{ $t('viberImg') }}</b> có chạy hàm kiểm tra
                FILTER_URL
                để trả về lỗi (nếu sai cấu trúc đường dẫn)
              </div>
            </div>
          </div>
          <div class="col-lg-6">
            <form-textarea :disabled="true" :row="6"
                           :label="$t('content')" :model="formModel" attribute="contentViber" :errors="formErrors">
            </form-textarea>
            <form-input :disabled="formModel.startTime > 0" :label="$t('viberActionText')" :model="formModel"
                        attribute="viberActionText" :errors="formErrors"></form-input>
            <form-input :disabled="formModel.startTime > 0" :label="$t('viberActionLink')" :model="formModel"
                        attribute="viberActionLink" :errors="formErrors" placeholder="http(s)://"></form-input>
            <form-input :disabled="formModel.startTime > 0" :label="$t('viberImg')" :model="formModel"
                        attribute="viberImg" :errors="formErrors" placeholder="http(s)://"></form-input>
          </div>
          <div class="col-lg-3 mb-2">
            <h5 class="c-config-content__title">{{ $t('preview') }}</h5>
            <div style="background: #efefef; border-radius: 5px;">
              <div class="p-2"
                   v-html="formModel.contentViber ? formModel.contentViber.replaceAll(`\n`, `<br/>`) : $t(`content`)"></div>
              <div v-if="formModel.viberActionText && formModel.viberActionLink && formModel.viberImg">
                <img :src="formModel.viberImg" style="width: 100%"/>
                <div class="p-2">
                  <a target="_blank" :href="formModel.viberActionLink" type="button"
                     class="btn btn-primary form-control text-white" style="border-radius: 30px; font-weight:100;">
                    {{ formModel.viberActionText }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </fieldset>

      <fieldset class="scheduler-border" v-if="formModel.type === 'zns' || (formModel.isAgainTwo && formModel.typeTwo === 'zns') || (formModel.isAgainThree && formModel.typeThree === 'zns')">
        <legend class="scheduler-border">{{ $t("zns") }}</legend>
        <div v-if="znsTemplates && znsTemplates.find(o => o._id == formModel.znsTemplate)" class="row">
          <div class="col-md-8">
            <h5 class="c-config-content__title">{{ $t('content') }}</h5>
            <div class="alert alert-info" v-html="znsTemplates.find(o => o._id == formModel.znsTemplate).desc"></div>

            <h5 class="c-config-content__title">{{ $t('paramList') }}</h5>
            <div v-if="znsTemplates.find(o => o._id == formModel.znsTemplate).params && znsTemplates.find(o => o._id == formModel.znsTemplate).params.length">
              <div class="c-template-table table-responsive">
                <table class="table table-hover c-role-table">
                  <thead>
                  <tr>
                    <th>{{ $t('name') }}</th>
                    <th>{{ $t('require') }}</th>
                    <th>{{ $t('dataType') }}</th>
                    <th>{{ $t('maxLength') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="item in znsTemplates.find(o => o._id == formModel.znsTemplate).params" :key="item._id">
                    <td>{{ item.name }}</td>
                    <td>{{ item.require ? $t('yes') : $t('no') }}</td>
                    <td>{{ item.dataType }}</td>
                    <td>{{ item.maxLength }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <h5 class="c-config-content__title">
              {{ $t('preview') }}
            </h5>
            <iframe :src="znsTemplates.find(o => o._id == formModel.znsTemplate).previewUrl"
                    style="border: none; height: 500px"></iframe>
          </div>
        </div>
        <div v-else>
          <div class="alert alert-warning text-center" v-if="!firstLoading">
            <span>{{ $t('noBrandNameSetUp') }}</span>
          </div>
        </div>
      </fieldset>
    </div>
  </div>

</template>

<script>
import CRUD from "@/mixins/CRUD";

export default {
  mixins: [CRUD],
  props: ['campaign'],
  components: {},
  data: function () {
    return {
      firstLoading: false,
      showList: false,
      service: `/message-campaign`,
      smsBrandNames: [],
      smsTemplates: [],
      viberBrandNames: [],
      znsTemplates: [],
      defaultFormModel: {
        sendParams: [],
        content: '',
        contentViber: '',
      },
      inputTypeOptions: [
        {value: 'text', text: this.$t('text')},
        {value: 'customField', text: this.$t('campaignContactFields')}
      ],
    };
  },
  computed: {
    customFieldOptions() {
      let options = [
        {value: null, text: this.$t('chooseCustomField')},
        {value: 'name', text: this.$t('name')},
        {value: "phone", text: this.$t("phone")},
        {value: 'desc', text: this.$t('desc')}
      ];
      this.campaign.contactCustomFields.forEach(item => {
        options.push({value: item.key, text: item.label});
      });
      return options
    }
  },
  methods: {
    copy(str) {
      this.$copyText(str).then(() => {
        this.$swal({
          text: this.$t('copied', [str]),
          icon: 'success',
          toast: true,
          timer: 1000,
          position: 'bottom-left'
        });
      }, () => {
        this.$swal({
          title: this.$t('error'),
          text: this.$t('copyFailed'),
          icon: 'error'
        });
      })
    },
    inputTypeChange(index) {
      if (this.formModel.sendParams[index].inputType !== 'text') {
        this.formModel.sendParams[index].value = null;
      } else {
        this.formModel.sendParams[index].value = ''
      }
    },
    saveNext() {
      let errors = [];
      if (this.formModel.type === 'sms' || (this.formModel.isAgainTwo && this.formModel.typeTwo === 'sms') || (this.formModel.isAgainThree && this.formModel.typeThree === 'sms')) {
        if (!this.formModel.content) {
          errors.push({value: "", msg: this.$t('notEmpty'), param: "content", location: "body"});
        } else if (this.formModel.type === 'ads' && ((this.formModel.content.length > 425 && !this.vietnamChar(this.formModel.content)) || (this.formModel.content.length > 201 && this.vietnamChar(this.formModel.content)))) {
          errors.push({value: "", msg: this.$t('smsTemplateContentPlaceHolder'), param: "content", location: "body"});
        }
        if (this.formModel.sendParams && this.formModel.sendParams.length > 0) {
          let i;
          for (i = 0; i < this.formModel.sendParams.length; i++) {
            if (!this.formModel.sendParams[i].value) {
              errors.push({value: "", msg: this.$t('notEmpty'), param: 'value', location: "body", index: i});
            }
          }
        }

        if (this.formModel.sendParams && this.formModel.sendParams.length > 0) {
          let i;
          for (i = 0; i < this.formModel.sendParams.length; i++) {
            if (!this.formModel.sendParams[i].value) {
              errors.push({value: "", msg: this.$t('notEmpty'), param: 'value', location: "body", index: i});
            }
          }
          let j;
          for (j = 0; j < this.formModel.sendParams.length; j++) {
            if (this.$utils.validSpecialChar(this.formModel.sendParams[j].value)) {
              errors.push({value: "", msg: this.$t('noSpecialChar'), param: 'value', location: "body", index: j});
            }
          }
        }
      }
      if (this.formModel.type === 'viber' || (this.formModel.isAgainTwo && this.formModel.typeTwo === 'viber') || (this.formModel.isAgainThree && this.formModel.typeThree === 'viber')) {
        if (!this.formModel.contentViber) {
          errors.push({value: "", msg: this.$t('notEmpty'), param: "contentViber", location: "body"});
        }
        if (!this.formModel.viberActionText && (this.formModel.viberActionLink || this.formModel.viberImg)) {
          errors.push({value: "", msg: this.$t('notEmpty'), param: "viberActionText", location: "body"});
        }
        if (!this.formModel.viberActionLink && (this.formModel.viberActionText || this.formModel.viberImg)) {
          errors.push({value: "", msg: this.$t('notEmpty'), param: "viberActionLink", location: "body"});
        }
        if (!this.formModel.viberImg && (this.formModel.viberActionLink || this.formModel.viberActionText)) {
          errors.push({value: "", msg: this.$t('notEmpty'), param: "viberImg", location: "body"});
        }
      }

      if (errors.length > 0) {
        this.formErrors = errors;
        return false;
      }
      this.save().then(data => {
        if (data) {
          this.$emit('next', 'contacts', data);
        }
      });
    },
    getMatchesParam(str) {
      if (!str) return "";
      let matchStr = "";
      let paramObj = {};
      let rsArray = [];

      for (let i in str) {
        if (str.charAt(i) === '{') {
          matchStr = String(str.charAt(i));
          continue;
        }

        if (matchStr.includes("{") && str.charAt(i) !== '}') {
          matchStr = matchStr.concat(str.charAt(i));
          continue;
        }

        if (matchStr.includes('{') && str.charAt(i) == '}') {
          matchStr = matchStr.concat(str.charAt(i));

          let configPart = matchStr.replace("{", "").replace("}", "").split(',');
          if (!configPart || configPart.length != 2 || Number.isNaN(configPart[1]) || configPart[1].trim() == "" || configPart[0] === "")
            continue;

          paramObj["key"] = matchStr;
          paramObj["value"] = configPart[1].trim();

          rsArray.push(paramObj);
          paramObj = {};
          matchStr = '';
        }
      }
      return rsArray;
    },
    loadParam() {
      if (this.formModel.content) {
        let paramCounts = this.getMatchesParam(this.formModel.content);
        if (paramCounts && paramCounts.length > 0) {
          let keyParams = this.formModel.sendParams.map(p => p.key);
          let paramCountKey = paramCounts.map(p => p.key);
          paramCounts.forEach(pa => {
            if (keyParams.includes(pa.key)) {
              this.formModel.sendParams.find(pc => pc.key == pa.key).length = pa.value;
            } else {
              this.formModel.sendParams.push({
                key: pa.key,
                inputType: 'text',
                length: pa.value,
                value: ''
              });
            }
          });

          keyParams.forEach(pa => {
            if (!paramCountKey.includes(pa)) {
              this.formModel.sendParams = this.formModel.sendParams.filter(p => p.key != pa);
            }
          })
        } else {
          this.formModel.sendParams = [];
        }
      } else {
        this.formModel.sendParams = [];
      }
    },
    vietnamChar(content) {
      let vnmChars = [
        'à', 'á', 'ạ', 'ả', 'ã', 'â', 'ầ', 'ấ', 'ậ', 'ẩ', 'ẫ', 'ă', 'ằ', 'ắ', 'ặ', 'ẳ', 'ẵ',
        'è', 'é', 'ẹ', 'ẻ', 'ẽ', 'ê', 'ề', 'ế', 'ệ', 'ể', 'ễ',
        'ì', 'í', 'ị', 'ỉ', 'ĩ',
        'ò', 'ó', 'ọ', 'ỏ', 'õ', 'ô', 'ồ', 'ố', 'ộ', 'ổ', 'ỗ', 'ơ', 'ờ', 'ớ', 'ợ', 'ở', 'ỡ',
        'ù', 'ú', 'ụ', 'ủ', 'ũ', 'ư', 'ừ', 'ứ', 'ự', 'ử', 'ữ',
        'ỳ', 'ý', 'ỵ', 'ỷ', 'ỹ',
        'đ', 'Đ',
        'À', 'Á', 'Ạ', 'Ả', 'Ã', 'Â', 'Ầ', 'Ấ', 'Ậ', 'Ẩ', 'Ẫ', 'Ă', 'Ằ', 'Ắ', 'Ẳ', 'Ẵ', 'Ặ',
        'È', 'É', 'Ẹ', 'Ẻ', 'Ẽ', 'Ê', 'Ề', 'Ế', 'Ệ', 'Ể', 'Ễ',
        'Ì', 'Í', 'Ị', 'Ỉ', 'Ĩ',
        'Ò', 'Ó', 'Ọ', 'Ỏ', 'Õ', 'Ô', 'Ồ', 'Ố', 'Ộ', 'Ổ', 'Ỗ', 'Ơ', 'Ờ', 'Ớ', 'Ợ', 'Ở', 'Ỡ',
        'Ù', 'Ú', 'Ụ', 'Ủ', 'Ũ', 'Ư', 'Ừ', 'Ứ', 'Ự', 'Ử', 'Ữ',
        'Ỳ', 'Ý', 'Ỵ', 'Ỷ', 'Ỹ'
      ];

      if (content) {
        vnmChars.forEach(c => {
          if (content.includes(c)) {
            return true;
          }
        })
      }
      return false;
    }
  },
  watch: {
    "formModel.content": {
      handler() {
        this.loadParam();
      }
    }
  },
  async mounted() {
    this.firstLoading = true;
    let loader = this.$loading.show();
    this.formModel = {};
    this.formModel = Object.assign({}, this.defaultFormModel);
    let response = await this.$service.get(`${this.service}/${this.campaign._id}`);
    response.data.smsBrandName = response.data.smsBrandName ? response.data.smsBrandName : null;
    response.data.smsTemplate = response.data.smsTemplate ? response.data.smsTemplate : null;
    response.data.viberActionText = response.data.viberActionText ? response.data.viberActionText : null;
    response.data.viberActionLink = response.data.viberActionLink ? response.data.viberActionLink : null;
    response.data.viberImg = response.data.viberImg ? response.data.viberImg : null;
    response.data.viberBrandName = response.data.viberBrandName ? response.data.viberBrandName : null;
    response.data.znsTemplate = response.data.znsTemplate ? response.data.znsTemplate : null;
    response.data.sendParams = response.data.sendParams ? response.data.sendParams : [];
    response.data.content = response.data.content ? response.data.content : '';
    response.data.contentViber = response.data.contentViber ? response.data.contentViber : '';

    this.formModel = response.data;
    this.formModel.id = this.formModel._id;

    let params = {
      page: 1,
      pageSize: 500,
      status: 'activated',
      client: this.campaign.client._id
    }

    //sms: cần lấy brandname và sms
    if (this.formModel.type === 'sms' || (this.formModel.isAgainTwo && this.formModel.typeTwo === 'sms') || (this.formModel.isAgainThree && this.formModel.typeThree === 'sms')) {
      let response = await this.$service.get("/sms-brand-name", {
        params: params
      });
      this.smsBrandNames = response.data.docs;
      response = await this.$service.get("/sms-template", {params: params});
      this.smsTemplates = response.data.docs;
      this.loadParam();
    }
    if (this.formModel.type === 'viber' || (this.formModel.isAgainTwo && this.formModel.typeTwo === 'viber') || (this.formModel.isAgainThree && this.formModel.typeThree === 'viber')) {
      let response = await this.$service.get("/viber-brand-name", {
        params: params
      });
      this.viberBrandNames = response.data.docs;
    }
    if (this.formModel.type === 'zns' || (this.formModel.isAgainTwo && this.formModel.typeTwo === 'zns') || (this.formModel.isAgainThree && this.formModel.typeThree === 'zns')) {
      let response = await this.$service.get("/zns-template", {params: params});
      this.znsTemplates = response.data.docs;
    }
    this.firstLoading = false;
    loader.hide();
  },
  i18n: {
    messages: {
      vi: {
        sms: "SMS",
        viber: "Viber",
        zns: "Zalo ZBS",
        content: "Nội dung",
        paramList: "Danh sách tham số",
        preview: "Xem trước",
        require: "Bắt buộc",
        dataType: "Loại dữ liệu",
        maxLength: "Độ dài tối đa",
        noBrandNameSetUp: "Khách hàng chưa có brand name nào!",
        smsContent: "Nội dung SMS",
        copied: "Đã sao chép"
      },
      en: {
        sms: "SMS",
        viber: "Viber",
        zns: "Zalo ZBS",
        content: "Nội dung",
        paramList: "Danh sách tham số",
        preview: "Xem trước",
        require: "Bắt buộc",
        dataType: "Loại dữ liệu",
        maxLength: "Độ dài tối đa",
        noBrandNameSetUp: "Khách hàng chưa có brand name nào!",
        smsContent: "Nội dung SMS",
        copied: "Đã sao chép"
      }
    }
  }

}
</script>

<style lang="scss">
.iphone {
  display: block;
  float: left;
  border: solid 10px #000;
  width: 336px;
  height: 300px;
  padding: 0px;
  border-radius: 50px 50px 0 0;
  background: #fff;
  -webkit-box-shadow: 0px 0px 0px 5px #131313;
  -moz-box-shadow: 0px 0px 0px 5px #131313;
  box-shadow: 0px 0px 0px 5px #131313;

  .silence-switch {
    position: absolute;
    margin-left: -19px;
    margin-top: 90px;
    width: 4px;
    height: 30px;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
  }

  .volume-rocker-top {
    position: absolute;
    margin-left: -19px;
    margin-top: 140px;
    width: 4px;
    height: 50px;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
  }

  .volume-rocker-bottom {
    position: absolute;
    margin-left: -19px;
    margin-top: 200px;
    width: 4px;
    height: 50px;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
  }

  .power-button {
    position: absolute;
    margin-left: 350px;
    margin-top: 200px;
    width: 4px;
    height: 70px;
    border-bottom-right-radius: 10px;
    border-top-right-radius: 10px;
  }

  .top-section {
    background: #f6f6f7;
    height: 93px;
    margin: 0px;
    border-top-right-radius: 40px;
    border-top-left-radius: 40px;
    border-bottom: #e6e6e6 1px solid;
  }

  .top-section-time {
    position: absolute;
    margin-left: 30px;
    margin-top: 8px;
    font-size: 12px;
    font-weight: bold;
  }

  .top-section-middle {
    margin: auto;
    width: 180px;
    background: black;
    height: 20px;
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    padding-top: 5px;
  }

  .top-section-user-pic {
    margin: auto;
    margin-top: 8px;
    width: 30px;
    height: 40px;
    border-radius: 100%;
    background-color: none;
    font-size: 40px;
    color: #999999;
  }

  .top-section-user-name {
    margin: auto;
    margin-top: 12px;
    background: none;
    height: 10px;
    width: 100px;
    font-size: 10px;
    text-align: center;
  }

  .speaker {
    width: 60px;
    height: 8px;
    background: #2e2e2e;
    margin-left: 55px;
    border-radius: 10px;
  }

  .front-camera {
    height: 8px;
    width: 8px;
    background: #005063;
    border-radius: 100%;
    margin-left: 70px;
  }

  .top-section-symbols {
    position: absolute;
    margin-left: 265px;
    margin-top: 10px;
    font-size: 12px;
  }

  .arrow {
    position: absolute;
    border: solid #3478f6;
    border-width: 0 3px 3px 0;
    display: inline-block;
    padding: 5px;
    margin-top: 45px;
    margin-left: 13px;
    border-radius: 2px;
    opacity: 0.9;
  }

  .arrow:hover {
    cursor: pointer;
    opacity: 1;
  }

  .left {
    transform: rotate(135deg);
    -webkit-transform: rotate(135deg);
  }

  .messages-section {
    margin-top: 85px;
    background: #fff;
    height: 190px;
    overflow: scroll;
    font-size: 13px;
    font-weight: 600;
  }

  .messages-section::-webkit-scrollbar {
    display: none;
  }

  .keyboard-keys a:hover {
    cursor: pointer;
    background: #8f929c;
  }

  .back_space > i {
    font-size: 14px;
  }

  .message {
    border-radius: 20px 20px 20px 20px;
    margin: 0 15px 10px;
    padding: 10px 15px;
    position: relative;
    animation-name: fadeInOpacity;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-duration: 0.4s;
  }

  @keyframes fadeInOpacity {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .message.to {
    background-color: #3478f6;
    color: #fff;
    margin-left: 80px;
    transition: width 2s;
  }

  .message.from {
    background-color: #e9e9ea;
    color: #363636;
    margin-right: 80px;
  }

  .message.to:before {
    content: "";
    width: 0;
    height: 0;
    left: 93%;
    top: 30%;
    position: absolute;
    border-top: 13px solid transparent;
    border-left: 26px solid #3478f6;
    border-bottom: 13px solid transparent;
    border-radius: 40px;
    -ms-transform: rotate(40deg); /* IE 9 */
    transform: rotate(40deg);
  }

  .message.from:before {
    content: "";
    width: 0;
    height: 0;
    right: 93%;
    top: 60%;
    position: absolute;
    border-top: 13px solid transparent;
    border-right: 26px solid #e9e9ea;
    border-bottom: 13px solid transparent;
    border-radius: 40px;
    -ms-transform: rotate(-40deg); /* IE 9 */
    transform: rotate(-40deg);
  }


  .selectDisable {
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }

  textarea:focus, input:focus {
    outline: none;
  }

}


</style>